var map = {
	"./editorBaseApi": [
		62024
	],
	"./editorBaseApi.js": [
		62024
	],
	"./editorSimpleWorker": [
		46211
	],
	"./editorSimpleWorker.js": [
		46211
	],
	"./editorWorker": [
		5323
	],
	"./editorWorker.js": [
		5323
	],
	"./editorWorkerHost": [
		14419
	],
	"./editorWorkerHost.js": [
		14419
	],
	"./findSectionHeaders": [
		11454
	],
	"./findSectionHeaders.js": [
		11454
	],
	"./getIconClasses": [
		87397
	],
	"./getIconClasses.js": [
		87397
	],
	"./languageFeatureDebounce": [
		98971
	],
	"./languageFeatureDebounce.js": [
		98971
	],
	"./languageFeatures": [
		53584
	],
	"./languageFeatures.js": [
		53584
	],
	"./languageFeaturesService": [
		17630
	],
	"./languageFeaturesService.js": [
		17630
	],
	"./languageService": [
		90848
	],
	"./languageService.js": [
		90848
	],
	"./languagesAssociations": [
		15409
	],
	"./languagesAssociations.js": [
		15409
	],
	"./languagesRegistry": [
		25194
	],
	"./languagesRegistry.js": [
		25194
	],
	"./markerDecorations": [
		82081
	],
	"./markerDecorations.js": [
		82081
	],
	"./markerDecorationsService": [
		14113
	],
	"./markerDecorationsService.js": [
		14113
	],
	"./model": [
		29257
	],
	"./model.js": [
		29257
	],
	"./modelService": [
		45310
	],
	"./modelService.js": [
		45310
	],
	"./resolverService": [
		95011
	],
	"./resolverService.js": [
		95011
	],
	"./semanticTokensDto": [
		79360
	],
	"./semanticTokensDto.js": [
		79360
	],
	"./semanticTokensProviderStyling": [
		6222
	],
	"./semanticTokensProviderStyling.js": [
		6222
	],
	"./semanticTokensStyling": [
		69673
	],
	"./semanticTokensStyling.js": [
		69673
	],
	"./semanticTokensStylingService": [
		32336
	],
	"./semanticTokensStylingService.js": [
		32336
	],
	"./textModelSync/textModelSync.impl": [
		47032
	],
	"./textModelSync/textModelSync.impl.js": [
		47032
	],
	"./textModelSync/textModelSync.protocol": [
		13407,
		3407
	],
	"./textModelSync/textModelSync.protocol.js": [
		13407,
		3407
	],
	"./textResourceConfiguration": [
		56903
	],
	"./textResourceConfiguration.js": [
		56903
	],
	"./treeSitterParserService": [
		15086
	],
	"./treeSitterParserService.js": [
		15086
	],
	"./treeViewsDnd": [
		55514
	],
	"./treeViewsDnd.js": [
		55514
	],
	"./treeViewsDndService": [
		32405
	],
	"./treeViewsDndService.js": [
		32405
	],
	"./unicodeTextModelHighlighter": [
		42454
	],
	"./unicodeTextModelHighlighter.js": [
		42454
	],
	"monaco-editor/esm/vs/editor/common/services/editorBaseApi": [
		62024
	],
	"monaco-editor/esm/vs/editor/common/services/editorBaseApi.js": [
		62024
	],
	"monaco-editor/esm/vs/editor/common/services/editorSimpleWorker": [
		46211
	],
	"monaco-editor/esm/vs/editor/common/services/editorSimpleWorker.js": [
		46211
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorker": [
		5323
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorker.js": [
		5323
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorkerHost": [
		14419
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorkerHost.js": [
		14419
	],
	"monaco-editor/esm/vs/editor/common/services/findSectionHeaders": [
		11454
	],
	"monaco-editor/esm/vs/editor/common/services/findSectionHeaders.js": [
		11454
	],
	"monaco-editor/esm/vs/editor/common/services/getIconClasses": [
		87397
	],
	"monaco-editor/esm/vs/editor/common/services/getIconClasses.js": [
		87397
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatureDebounce": [
		98971
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatureDebounce.js": [
		98971
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatures": [
		53584
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatures.js": [
		53584
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeaturesService": [
		17630
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeaturesService.js": [
		17630
	],
	"monaco-editor/esm/vs/editor/common/services/languageService": [
		90848
	],
	"monaco-editor/esm/vs/editor/common/services/languageService.js": [
		90848
	],
	"monaco-editor/esm/vs/editor/common/services/languagesAssociations": [
		15409
	],
	"monaco-editor/esm/vs/editor/common/services/languagesAssociations.js": [
		15409
	],
	"monaco-editor/esm/vs/editor/common/services/languagesRegistry": [
		25194
	],
	"monaco-editor/esm/vs/editor/common/services/languagesRegistry.js": [
		25194
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorations": [
		82081
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorations.js": [
		82081
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorationsService": [
		14113
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorationsService.js": [
		14113
	],
	"monaco-editor/esm/vs/editor/common/services/model": [
		29257
	],
	"monaco-editor/esm/vs/editor/common/services/model.js": [
		29257
	],
	"monaco-editor/esm/vs/editor/common/services/modelService": [
		45310
	],
	"monaco-editor/esm/vs/editor/common/services/modelService.js": [
		45310
	],
	"monaco-editor/esm/vs/editor/common/services/resolverService": [
		95011
	],
	"monaco-editor/esm/vs/editor/common/services/resolverService.js": [
		95011
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensDto": [
		79360
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensDto.js": [
		79360
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensProviderStyling": [
		6222
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensProviderStyling.js": [
		6222
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStyling": [
		69673
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStyling.js": [
		69673
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStylingService": [
		32336
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStylingService.js": [
		32336
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.impl": [
		47032
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.impl.js": [
		47032
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.protocol": [
		13407,
		3407
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.protocol.js": [
		13407,
		3407
	],
	"monaco-editor/esm/vs/editor/common/services/textResourceConfiguration": [
		56903
	],
	"monaco-editor/esm/vs/editor/common/services/textResourceConfiguration.js": [
		56903
	],
	"monaco-editor/esm/vs/editor/common/services/treeSitterParserService": [
		15086
	],
	"monaco-editor/esm/vs/editor/common/services/treeSitterParserService.js": [
		15086
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDnd": [
		55514
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDnd.js": [
		55514
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDndService": [
		32405
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDndService.js": [
		32405
	],
	"monaco-editor/esm/vs/editor/common/services/unicodeTextModelHighlighter": [
		42454
	],
	"monaco-editor/esm/vs/editor/common/services/unicodeTextModelHighlighter.js": [
		42454
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 10131;
module.exports = webpackAsyncContext;